module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/20161231/sp_menu-e81396209e93a43479c10b19e4bdcd71.png";